<template>
  <transition name="fade">
    <div class="modal" v-if="show">
      <div class="modalOverlay"></div>
      <div class="close" v-on:click="close(false)"></div>
      <div class="modalContent">
        <div class="modalContentIn">
          <div class="loading" v-if="loading"></div>
          <div v-else>
            <div class="monthName">{{monthName}}</div>
            <div class="contentCnt" :class="{cc2: i%2 !== 0}"
              v-for="(items, i) in data" :key="i">
              <div class="imgCnt" v-if="i%2 === 0">
                <img :src="items.img">
                <div class="caption">{{items.caption}}</div>
              </div>
              <div class="infoCnt">
                <div class="infoItem" v-for="(item, i2) in items.items" :key="i2">
                  <div class="num" v-if="(i2 + i * 7) + 1 < 10">0{{(i2 + i * 7) + 1}}</div>
                  <div class="num" v-else>{{(i2 + i * 7) + 1}}</div>
                  <p>{{item.content}}</p>
                </div>
              </div>
              <div class="imgCnt" v-if="i%2 !== 0">
                <img :src="items.img">
                <div class="caption">{{items.caption}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Confirmation ref="confirmDialog"/>
    </div>
  </transition>
</template>

<script>
import Confirmation from '@/components/Confirmation.vue';

export default {
  name: 'winner',
  components: { Confirmation },
  data() {
    return {
      show: false,
      loading: true,
      next: null,
      monthName: '',
      data: null,
    };
  },
  methods: {
    open(m, next) {
      this.monthName = m;
      this.next = next;
      this.show = true;
      this.loading = true;
      this.getData();
    },
    getData() {
      this.$http.get(this.$config.uri(`misc/nuklir/${this.monthName}`)).then((r) => {
        this.data = (r.data.status === 200) ? r.data.data : null;
        this.loading = false;
      });
    },
    close(b) {
      this.show = false;
      if (this.next) this.next(b, this.user);
    },
  },
};
</script>

<style scoped lang="scss">
.modal{
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  z-index: 9991;
  overflow: auto;
  .modalOverlay{
    position: fixed;
    top: 0; left: 0; right: 0; bottom: 0;
    background-color: rgba(0,0,0,.7);
    background-color: #202020;
    background-position: center;
    background-repeat: no-repeat;
    background-size: 140% auto;
    z-index: 1;
    // backdrop-filter: saturate(180%) blur(20px);
    opacity: 1;
    // opacity: .3;
  }
  .close{
    width: 46px; height: 46px;
    border-radius: 3px;
    position: fixed;
    right: 20px; top: 20px;
    background-image: url(../assets/close-white.png);
    background-color: #444;
    background-size: 18px auto;
    background-position: center;
    background-repeat: no-repeat;
    z-index: 91;
    cursor: pointer;
    transition: all .3s ease;
    @media (max-width: 740px) {
      width: 30px; height: 30px;
      background-size: 12px auto;
      border-radius: 50%;
      background-color: red;
      right: 10px; top: 10px;
    }
    &:hover{
      background-image: url(../assets/close.png);
      background-color: #eee;
    }
  }
  .modalContent{
    position: relative;
    z-index: 2;
    box-sizing: border-box;
    .modalContentIn{
      width: 1200px;
      margin: 40px auto 0;
      @media (max-width: 1280px) {
        width: auto;
        margin: 40px 20px 0;
      }
      @media (max-width: 740px) {
        padding-bottom: 40px;
      }
    }
    .loading{
      background-image: url(../assets/loading.svg);
      background-position: center;
      background-size: 64px auto;
      background-repeat: no-repeat;
      position: fixed;
      left: 0; right: 0; top: 0; bottom: 0;
    }
    .monthName{
      font-size: 64px;
      text-align: center;
      color: #f15939;
      font-weight: 800;
      padding: 0 0 20px;
      @media (max-width: 960px) {
        font-size: 46px;
      }
      @media (max-width: 740px) {
        font-size: 26px;
        margin-bottom: -20px;
      }
    }
    .contentCnt{
      display: flex;
      align-items: center;
      padding: 0 0 60px;
      @media (max-width: 740px) {
        display: block;
        padding: 0;
      }
      .imgCnt{
        width: calc(100% - 500px);
        @media (max-width: 1280px) {
          width: calc(100% - 480px);
        }
        @media (max-width: 1100px) {
          width: calc(100% - 400px);
        }
        @media (max-width: 740px) {
          width: auto;
          margin: 30px 0;
        }
        img{
          width: 100%;
        }
        .caption{
          color: #fff;
          font-size: 13px;
          padding-top: 10px;
          @media (max-width: 960px) {
            font-size: 12px;
          }
          @media (max-width: 740px) {
            font-size: 11px;
            padding-top: 4px;
          }
        }
      }
      .infoCnt{
        width: 500px;
        padding-left: 80px;
        box-sizing: border-box;
        @media (max-width: 1280px) {
          width: 480px;
        }
        @media (max-width: 1100px) {
          width: 400px;
          padding-left: 50px;
        }
        @media (max-width: 740px) {
          width: auto;
          padding-left: 10px;
        }
        .infoItem{
          position: relative;
          background-color: #9b9b93;
          padding: 10px;
          padding-left: 60px;
          margin-bottom: 10px;
          border-radius: 20px;
          @media (max-width: 1100px) {
            padding-left: 44px;
          }
          @media (max-width: 740px) {
            border-radius: 10px;
            padding-left: 40px;
          }
          p{
            margin: 0;
            color: #000;
            @media (max-width: 1100px) {
              font-size: 14px;
            }
            @media (max-width: 740px) {
              font-size: 13px;
            }
          }
          .num{
            position: absolute;
            color: #000;
            background-color: #f2f2e6;
            padding: 8px 12px;
            border-radius: 20px;
            font-size: 36px;
            font-weight: 800;
            left: -20px; top: 50%;
            transform: translateY(-50%);
            @media (max-width: 1100px) {
              font-size: 26px;
            }
            @media (max-width: 740px) {
              left: -10px;
              font-size: 18px;
              padding: 6px 10px;
              border-radius: 8px;
            }
          }
        }
      }
      &.cc2{
        .infoCnt{
          padding-right: 80px;
          padding-left: 0;
          @media (max-width: 740px) {
            padding-right: 0;
            padding-left: 10px;
          }
        }
      }
    }
  }
}
</style>
